import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileManager} from "../../../../shared/interface/file-manager";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {PageManager} from "../../../../shared/interface/page-manager";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {FilterService} from "../../../../shared/services/filter.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {FileManagerPageService} from "../../../../shared/services/file-manager-page.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {Profile} from "../../../../shared/interface/profile";

@Component({
  selector: 'app-page-list',
  templateUrl: './page-list.component.html',
  styleUrls: ['./page-list.component.scss']
})
export class PageListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  totalData = 0;
  displayedColumns: string[] = ['fileName', 'cratedAt', 'createdBy', 'download'];
  pageManager: PageManager[] = [];
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;
  sortBy = 'uuid';
  sortOrder = 'desc';
  idValue: string = null;
  initialFilters: any;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private fileManagerPageService: FileManagerPageService,
    private auth: AuthService,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.fileManagerPageService.getFileManagerPageListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<PageManager>) => {
          this.pageManager = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.resetFilters();
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.loadListData();
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.loadListData();
    });
  }

  loadListData(): void {
    this.fileManagerPageService.loadList(this.buildFilters(),
      this.paginator?.pageIndex, this.paginator?.pageSize,
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
    );

  }

  filter(): void {
    this.loadListData();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({}, filters);
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    filters.catalogId = this.idValue;

    return filters;
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.loadListData();
  }

  addPage(): void {
    this.router.navigate(['serwis-plikow/strona/dodaj']);
  }

  deletePage(uuid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć strone ?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileManagerPageService.deletePage(uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto strone', '', {duration: 2000});
              this.loadListData();
            },
            error: (response: HttpErrorResponse) => {
              if (response.status.toString() === '422' )
              {
                this.snack.open('Strona jest podpięta do katalogu', response.status.toString(), {duration: 5000});

              } else {
                this.snack.open(response.error.error.text, response.status.toString(), {duration: 5000});
              }
            }
          });
      }
    });
  }


}
